module.exports = __webpack_public_path__ + "_square-mask.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/_square-mask.svg
// module id = KZqe
// module chunks = 0